import React from 'react';
import { useAccordionButton } from 'react-bootstrap';

interface IToggleProps {
  as?: React.ElementType;
  children: React.ReactElement | string;
  eventKey: string;
  ref?: React.Ref<any>;
  className?: string;
  style?: React.CSSProperties;
}
const AccordionCustomToggle = ({ as, children, eventKey, ref, className, style }: IToggleProps): React.ReactElement => {
  const decoratedOnClick = useAccordionButton(eventKey, () => console.log('totally custom!'));
  const Tag = as ? as : 'div';
  return as ? (
    <Tag style={style} className={className} ref={ref} onClick={decoratedOnClick}>
      {children}
    </Tag>
  ) : (
    <div style={style} ref={ref} className={className} onClick={decoratedOnClick}>
      {children}
    </div>
  );
};

export default AccordionCustomToggle;
